import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch, WithScope } from '@mews-commander/types';
import { startEntityEditing } from '../../../../entityManagement/actions';
import EntityEditLink, { EntityEditLinkProps } from '../../../../entityManagement/components/EntityEditLink';
import { getResourceName } from '../../../selectors/resources';

type StateProps = Pick<EntityEditLinkProps, 'name'>;
type DispatchProps = Pick<EntityEditLinkProps, 'onEdit'>;
interface OwnProps extends WithScope {
    id: string;
}

export default connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        name: getResourceName,
    }),
    (dispatch: CommanderThunkDispatch, { id, scope }) => ({
        onEdit: () => dispatch(startEntityEditing(id, scope)),
    })
)(EntityEditLink);
